import { stringUtils } from "@ardoq/common-helpers";
import DOMPurify from "dompurify";
const escapeHTML = (str) => {
  return stringUtils.ensureString(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;").replace(/\//g, "&#x2F;");
};
const unescapeHTML = (str) => {
  return stringUtils.ensureString(str).replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#039;/g, "'").replace(/&#x2F;/g, "/").replace(/&amp;/g, "&");
};
const fixSVGEscapedName = (str, maxLength) => {
  const escaped = stringUtils.ensureString(str).replace(/&amp;/gi, "&").replace(/&quot;/gi, '"').replace(/&#039;/gi, "'").replace(/&lt;/gi, "").replace(/&gt;/gi, "").replace(/&#x2F;/gi, "/");
  return maxLength && escaped.length > maxLength ? `${escaped.substring(0, maxLength)} ...` : escaped;
};
const permissive = {
  ALLOWED_TAGS: [
    "a",
    "b",
    "blockquote",
    "br",
    "code",
    "del",
    "em",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr",
    "i",
    "img",
    "li",
    "ol",
    "p",
    "pre",
    "s",
    "span",
    "strike",
    "strong",
    "table",
    "tbody",
    "td",
    "tfooter",
    "th",
    "thead",
    "tr",
    "ul",
    // for video
    "iframe"
  ],
  ALLOWED_ATTR: [
    // tables
    "align",
    "colspan",
    "rowspan",
    // general
    "id",
    "class",
    "style",
    // anchors
    "href",
    "rel",
    "target",
    "title",
    // img and iframe (for video)
    "src",
    "alt",
    // iframe tags (for video)
    "width",
    "height",
    "frameborder",
    "webkitallowfullscreen",
    "mozallowfullscreen",
    "allowfullscreen"
  ],
  ALLOW_DATA_ATTR: true
};
const strict = {
  ALLOWED_TAGS: [
    "a",
    "b",
    "blockquote",
    "br",
    "code",
    "del",
    "em",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr",
    "i",
    "li",
    "ol",
    "p",
    "pre",
    "s",
    "span",
    "strike",
    "strong",
    "table",
    "tbody",
    "td",
    "tfooter",
    "th",
    "thead",
    "tr",
    "ul"
  ],
  ALLOWED_ATTR: ["href", "target"],
  ALLOW_DATA_ATTR: false
};
const svg = {
  USE_PROFILES: {
    svg: true
  }
};
const purifyOptions = {
  strict,
  permissive,
  svg
};
const sanitize = (html, sanitationLevel) => DOMPurify.sanitize(html, purifyOptions[sanitationLevel]);
export {
  escapeHTML,
  fixSVGEscapedName,
  sanitize,
  unescapeHTML
};
//# sourceMappingURL=index.js.map
